export default __webpack_public_path__ + "static/media/404.03658ac4.svg";